// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"gamePage_wrapper__2IRQA","bg":"gamePage_bg__5mox9","feeding":"gamePage_feeding__1IX4t","version":"gamePage_version__1_jI5"};